import React, { PropsWithChildren, useEffect, useState } from 'react';
import { isValid, parseISO } from 'date-fns';

export const AccountIdContext = React.createContext({
  billingDate: undefined,
  setBillingDate: undefined,
  accountId: undefined,
  setAccountId: undefined,
  isBillingDateOutbound: undefined,
  setIsBillingDateOutBound: undefined,
  paymentDueDateStrategy: undefined,
  setPaymentDueDateStrategy: undefined,
});

function parseBillingDateFromStorage(accountId: string | null): Date {
  const stored = localStorage.getItem(`${accountId}-billing-date`);
  if (stored) {
    const parsed = parseISO(stored);
    if (isValid(parsed)) return parsed;
  }
  return new Date();
}

export function AccountIdContextProvider({ children }: PropsWithChildren) {
  const [accountId, setAccountId] = useState(localStorage.getItem('accountId'));
  const [billingDate, setBillingDate] = useState(() => parseBillingDateFromStorage(accountId));
  const [isBillingDateOutbound, setIsBillingDateOutBound] = useState<boolean>(false);
  const [paymentDueDateStrategy, setPaymentDueDateStrategy] = useState<string>('Statement Day');

  useEffect(() => {
    localStorage.setItem('accountId', accountId);
  }, [accountId]);

  return (
    <AccountIdContext.Provider
      value={{ billingDate, setBillingDate, accountId, setAccountId, isBillingDateOutbound, setIsBillingDateOutBound, paymentDueDateStrategy, setPaymentDueDateStrategy }}>
      {children}
    </AccountIdContext.Provider>
  );
}

export function useAccountIdContext() {
  const context = React.useContext(AccountIdContext);
  if (context === undefined) {
    throw new Error('useAccountIdContext must be used within a AccountIdContextProvider');
  }
  return context;
}
